import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BakeryDiningIcon(props: IconProps) {
    return <Icon {...props} iconKey={"bakery_dining"}/>
}
